module.exports = __webpack_public_path__ + "img/skills-wind-dru-3.60efa2a9.png";